<template>
  <v-container class="containerFillHeight" fluid>

    <v-row no-gutters class="pb-5 mb-5 mx-md-2 px-md-2 mx-sm-1 px-sm-1">
      <div v-if="notificationLoading"
        class="text-xl font-Handel h-[calc(100vh-150px)] !bg-[#000000bd] rounded-3xl overflow-auto w-full  relative p-6">
        <LoadingSpinner class="bg-transparent !top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
      </div>
      <div v-else
        class=" text-xl font-Handel h-[calc(100vh-150px)] !bg-[#000000bd] rounded-3xl overflow-auto w-full  p-6">

        <v-row no-gutters class="!justify-between !items-center !px-4">
          <v-col class="!max-w-max !flex !items-center ">
            <v-avatar size="50">
              <v-img class="!border-2 " v-if="notification.data.user_image" :class="`${routeLink}-border`"
                position="top center" :src="`${notification.data.user_image}`" alt="" />
              <v-img  class="!border-2 " v-else :class="`${routeLink}-border`" position="top center"
                :src="require('@/assets/fav_icon/android-chrome-512x512.png')" alt="" />
            </v-avatar>
            <span class="ml-3 capitalize">{{ notification.data.subject }}</span>
          </v-col>
          <v-col class="!max-w-max !text-xs">{{ notification.time }}</v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="transparent" dark tile elevation="0">
              <!-- <v-card-title :class="`${routeLink}_fortext !text-2xl !break-words`">
                {{ notification.data.subject }}
              </v-card-title> -->
              <v-card-text class="!text-lg">
                <div class="!capitalize leading-[60px]">Dear {{ $store.getters.StateUser.data.name }},</div>
                {{ notification.data.message }}
                <div class="my-5">
                  {{  notification.data.add_message ? notification.data.add_message : '' }}
                </div>
                <div class="!capitalize my-5">Best Regards, <br>
                  <div class="">
                    {{ notification.data.sender_name }}
                  </div>
                </div>
              </v-card-text>
              <v-card-actions v-if="notification.data.user_image">
                <v-row>
                  <v-col>
                    <v-btn block class="rounded-lg " :class="`${routeLink}_color`" x-large
                      @click="acceptRequest(notification.nid, 1)">Accept</v-btn>
                  </v-col>
                  <v-col>
                    <v-btn block class="rounded-lg" @click="acceptRequest(notification.nid, 0)" x-large>Cancel</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import LoadingSpinner from '@/pages/front/straight/childs/LoadingSpinner.vue';
import axios from 'axios';

export default {
  data() {
    return {
      notification: {},
      notifications: [],
      notificationLoading: false,
    };
  },
  computed: {
    colorAsRoute() {
      if (this.routeLink == "straight") {
        return "#a07a1d";
      }
      else if (this.routeLink == "gay") {
        return "#88c3fa";
      }
      else if (this.routeLink == "lesbian") {
        return "#9e2eec";
      }
    },
  },
  methods: {
    async notifyUser(response) {
      const receiver_name = this.notification.data.sender_name;
      let messageData
      if (response == "Accepted") {
        messageData = `{"subject":"Date Request Accepted","message":"Congratulations! Your date request has been accepted by ${this.$store.getters.StateUser.data.name}. ${this.$store.getters.StateUser.data.name} are excited to meet you and get to know you better. Please check your chat messages for further details and to coordinate the date.", "add_message":" Thank You for using Magnum XL and we wish on your upcoming date.", "user_data":"${this.$store.getters.getCometUUID}" ,"user_id":"${this.$store.getters.StateUser.data.id}" , "user_image":"", "sender_name":"Magnum XL", "for_toast":"Your Date Request has been accepted. Go into chat section and start chatting..."  }`
      } else {
        messageData = `{"subject":"Date Request Rejected","message":"Your Date Request has been rejected by ${this.$store.getters.StateUser.data.name}. Our members have autonomy to accept or decline date request based on their own preferences. We wish you the best in your journey", "user_data":"${this.$store.getters.getCometUUID}" , "user_id":"${this.$store.getters.StateUser.data.id}", "for_toast":"Your Date Request has been rejected" ,"sender_name":"Magnum XL", "user_image":""}`
      }
      const resp = await axios.post('store-notification', {
        uuid: this.$store.getters.getCometUUID,
        notifiable_id: this.notification.data.user_id,
        data: messageData
      })

      console.log(resp);
    },
    async acceptRequest(id, status) {
      await axios.get(`user-request/update/${id}?status=${status}`)
      if (status == 1) {
        const options = {
          method: 'POST',
          url: `https://215679d1fe0ec5ce.api-us.cometchat.io/v3/users/${this.$store.getters.getCometUUID}/friends`,
          headers: {
            apiKey: '60a9cebf7986b8135abccd511310a90bda4dce4c',
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          data: { accepted: [`${this.notification.data.user_data}`] }
        };

        await axios
          .request(options)
          .then(function (response) {
            console.log(response.data);
          })
          .catch(function (error) {
            console.error(error);
          });
        this.notifyUser('Accepted')
        
        
        
      } else {
        this.notifyUser('Rejected')
      }
      // const resp = await axios.post('store-notification', {
      //   uuid: this.$store.getters.getCometUUID,
      //   notifiable_id: this.previewProfile.id,
      //   data: `{"subject":"Date Request ${ status === 0 ? 'Rejection' : 'Acceptance' }","message":"${ this.$store.getters.StateUser.data.name } ${ status === 0 ? 'Reject' : 'Accept' } Your Dinner Date Request" }`
      // })
    },
    async getNotification() {
      try {
        this.notificationLoading = true
        const resp = await axios.get("user-notifications");
        // console.log(JSON.parse(resp.data.data[0].data))
        this.notifications = resp.data.data;
        this.notifications.map((i) => { const data = JSON.parse(i.data); i.data = data; });
        const id = this.$route.params.id;
        this.notification = this.notifications.find((i) => i.nid == id);
        const notification_woDate = this.notifications.find((i) => i.nid == id);
        const timeGet = new Date(notification_woDate.created_at);
        this.notification.time = timeGet.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        this.notification.date = timeGet.toLocaleDateString()
        await axios.get(`read-notification/${id}`);

      }
      catch (error) {
        console.log(error.response, "~from notification");
      }
      finally {
        this.notificationLoading = false
      }
    }
  },
  created() {
    // this.getNotification();
  },
  watch: {
    '$route.params.id': {
      handler: function (id) {
        this.getNotification()
        console.log(this.notification, "from notification");
      },
      deep: true,
      immediate: true
    }
  },
  components: { LoadingSpinner }
};
</script>

<style scoped>
.straight_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(335deg,
      rgb(136 97 0) 0%,
      rgb(255 223 153) 53%,
      rgb(130 93 0 / 97%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gay_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(357deg,
      rgba(0, 240, 255, 1) 55%,
      rgba(0, 156, 255, 1) 75%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.straight_color {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(335deg,
      rgb(136 97 0) 0%,
      rgb(255 223 153) 53%,
      rgb(130 93 0 / 97%) 100%) !important;

}

.gay_color {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(200deg,
      rgba(0, 240, 255, 1) 0%,
      rgba(0, 156, 255, 1) 100%) !important;

}

.lesbian_color {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%) !important;

}

.straight-border {
  border-color: #a07a1d;
}

.gay-border {
  border-color: #88c3fa;
}

.lesbian-border {
  border-color: #9e2eec;
}
</style>
